import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StateJwtService {
  private banderaFuente = new BehaviorSubject<boolean>(true);
  banderaActual = this.banderaFuente.asObservable();

  enviarBandera(bandera: boolean) {
    this.banderaFuente.next(bandera);
  }
}
